// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Prop, Vue } from 'vue-property-decorator';
import { AppTheme } from '../_contracts';
/**
 * Symbols explanation:
 *   - "XL" stands for the `<Tile>` partial with the `TileSize.XL`.
 *   - "L" stands for the `<Tile>` partial with the `TileSize.L`.
 *   - "S" stands for the `<Tile>` partial with the `TileSize.S`.
 *   - "T" stands for the `<Tile>` partial with the `TileSize.S` and `titleOnImage` prop set to `false`.
 *   - "text-list" stands for the `<TextList>` partial.
 *   - "thumbnails-list" stands for the `<ThumbnailsList>` partial.
 *   - "big-thumbnails-list" stands for the `<ThumbnailsList>` partial with bigger images.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Paweł Korzeniewski <pawel.korzeniewski@movecloser.pl>
 */
export var TeaserBoxVersion;
(function (TeaserBoxVersion) {
    TeaserBoxVersion["1XL"] = "1XL";
    TeaserBoxVersion["2L"] = "2L";
    TeaserBoxVersion["8S"] = "8S";
    TeaserBoxVersion["4S"] = "4S";
    TeaserBoxVersion["8T"] = "8T";
    TeaserBoxVersion["L-2S-big-thumbnails-list"] = "L-2S-big-thumbnails-list";
    TeaserBoxVersion["L-2S-text-list"] = "L-2S-text-list";
    TeaserBoxVersion["L-2S-thumbnails-list"] = "L-2S-thumbnails-list";
    TeaserBoxVersion["L-4S"] = "L-4S";
    TeaserBoxVersion["L-8S"] = "L-8S";
    TeaserBoxVersion["L-5S-text-list"] = "L-5S-text-list";
    TeaserBoxVersion["6S-big-thumbnails-list"] = "6S-big-thumbnails-list";
    TeaserBoxVersion["6S-text-list"] = "6S-text-list";
    TeaserBoxVersion["6S-thumbnails-list"] = "6S-thumbnails-list";
    TeaserBoxVersion["6T-text-list"] = "6T-text-list";
    // new
    TeaserBoxVersion["L-4S-text-list"] = "L-4S-text-list";
    TeaserBoxVersion["L-4S-text-list-tabs"] = "L-4S-text-list-tabs";
    TeaserBoxVersion["XL-3S-text-list"] = "XL-3S-text-list";
    TeaserBoxVersion["XL-slider-3S-text-list"] = "XL-slider-3S-text-list";
})(TeaserBoxVersion || (TeaserBoxVersion = {}));
export const TeaserBoxWithoutTabs = [
    TeaserBoxVersion['L-5S-text-list'],
    TeaserBoxVersion['L-4S-text-list'],
    TeaserBoxVersion['XL-slider-3S-text-list']
];
/**
 * Describes the component capable of rendering the contents
 * from one, specific `TeaserBoxVersion`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class TeaserBoxInnerGrid extends Vue {
    /**
     * Callback for when ad banner is empty.
     */
    onEmptyCallback() {
        console.log('[TeaserBox] Ad banner is empty');
    }
}
__decorate([
    Prop({
        type: Array,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "items", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], TeaserBoxInnerGrid.prototype, "fallbackImage", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], TeaserBoxInnerGrid.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], TeaserBoxInnerGrid.prototype, "isMobile", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    })
], TeaserBoxInnerGrid.prototype, "readMoreLink", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "relatedService", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "shareService", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: AppTheme.Default
    })
], TeaserBoxInnerGrid.prototype, "theme", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "windowService", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "teaserBoxConfig", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], TeaserBoxInnerGrid.prototype, "eventBus", void 0);
